module.exports = __webpack_public_path__ + "static/03-3-684fe1fab08509f909b7a65585aaace5.jpg";